import React from "react";

import { PaymentFormRef, PaymentType } from "@clarkinc/payment-client";
import { PaymentMethodDetails } from "../models";

interface PaymentSelectionRef {
  tokenize: () => Promise<TokenizeResult>;
  showIframe: () => void;
  hideIframe: () => void;
}

interface TokenizeResult {
  isTokenized: boolean;
  suggestVerifyInformation: boolean;
  tokenId?: number;
}

const tokenize = (
  paymentFormRef: React.RefObject<PaymentFormRef>,
  updateSelectedCard: (newCard: PaymentMethodDetails) => void,
  tokenId?: number,
) => {
  if (tokenId !== undefined) {
    return () =>
      new Promise<TokenizeResult>((resolve) => {
        resolve({
          isTokenized: true,
          suggestVerifyInformation: false,
          tokenId,
        });
      });
  }

  return () =>
    new Promise<TokenizeResult>((resolve) => {
      const result: TokenizeResult = {
        isTokenized: false,
        suggestVerifyInformation: false,
        tokenId: undefined,
      };

      if (paymentFormRef.current == null) {
        resolve(result);

        return;
      }

      paymentFormRef.current
        .tokenizePaymentMethod(30000)
        .then((tokenizeResult) => {
          if (tokenizeResult.isSuccessful && tokenizeResult.tokenId !== null) {
            const newCard: PaymentMethodDetails = {
              mask: tokenizeResult.mask ?? "",
              isExpired: false,
              name: tokenizeResult.displayName ?? "",
              id: tokenizeResult.tokenId,
              type: "",
              isRewardsCard: false,
              isDefault: false,
            };

            switch (tokenizeResult.type) {
              case PaymentType.AmericanExpress:
                newCard.type = "American Express";

                break;
              case PaymentType.Visa:
                newCard.type = "Visa";

                break;
              case PaymentType.Discover:
                newCard.type = "Discover";

                break;
              case PaymentType.Mastercard:
                newCard.type = "Mastercard";

                break;
              default:
                break;
            }

            updateSelectedCard(newCard);

            result.isTokenized = true;
            result.tokenId = tokenizeResult.tokenId;
          } else {
            result.suggestVerifyInformation =
              tokenizeResult.suggestVerifyInformation;
          }
        })
        .finally(() => resolve(result));
    });
};

export { PaymentSelectionRef, tokenize };
